import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AuthService } from "./auth.service";
import { EntriesPipe } from "./entries.pipe";
import { FilterPipe } from "./filter.pipe";
import { SelectComponent } from "./select.component";
import { PercentInputComponent } from "./percent-input.component";
import { FlagsSelectComponent } from "./flags-select.component";
import { ImageInputComponent } from "./image-input.component";
import { HttpService } from "./http.service";
import { AuthGuard } from "./auth.guard";
import { MasterHttpService } from "../generated/master-http.service";
import { MasterService } from "../master/service";
import { MasterResolver } from "../master/master.resolver";
import { MultiSelectModule } from "primeng/multiselect";
import { ToastModule } from "primeng/toast";
import { MultiselectComponent } from "./multiselect.component";
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AttachmentInputComponent } from "./attachment-input.component";
import { FileHttpService } from "../generated/file-http.service";
import { InputTextModule } from 'primeng/inputtext';
import { KeyFilterModule } from 'primeng/keyfilter';
import { AppNav } from "../app.nav";
import { RouterModule } from "@angular/router";
import { ProjectOptionsResolver } from "./project-options.resolver";
import { ProjectHttpService } from "../generated/project-http.service";
import { SortableTableHeaderComponent } from "./sortable-table-header.component";
import { UserHttpService } from "../generated/user-http.service";
import { UserOptionsResolver } from "./user-options.resolver";
import { PackagingHttpService } from "../generated/packaging-http.service";
import { LengthPipe } from "./length.pipe"
import { CustomerFormComponent } from "./customer-form.component";
import { ClassificationsInputComponent } from "./classifications-input.component";
import { MultiuserselectComponent } from "./multiuserselect.component";
import { UserSelectComponent } from "./userselect.component";
import { TooltipComponent } from './tooltip.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CustomerOptionsResolver } from "./customer-options.resolver";
import { CustomerHttpService } from "../generated/customer-http.service";
import { LightboxModule } from 'primeng/lightbox';
import { FloorPipe } from "./floor.pipe";
import { ImageTaglineInputComponent } from "./image-tagline-input.component";
import { TendencyPipe } from "./tendency.pipe";
import { RecycabilityClassificationPipe } from "./recycability-classification.pipe";
import { IntersectionObserverComponent } from "./intersection-observer";
import { GlobalizationHttpService } from "../generated/globalization-http.service";
import { TranslationsFormComponent } from "./translations-form.component";
import { PdfButtonComponent } from "./pdf-button.component";
import { PrintHttpService } from "../generated/print-http.service";
import { DecimalInputComponent } from "./decimal-input.component";

@NgModule({
  declarations: [
    EntriesPipe,
    FilterPipe,
    SelectComponent,
    UserSelectComponent,
    MultiselectComponent,
    MultiuserselectComponent,
    PercentInputComponent,
    DecimalInputComponent,
    FlagsSelectComponent,
    ImageInputComponent,
    ImageTaglineInputComponent,
    AttachmentInputComponent,
    CustomerFormComponent,
    AppNav,
    SortableTableHeaderComponent,
    LengthPipe,
    FloorPipe,
    ClassificationsInputComponent,
    TooltipComponent,
    TendencyPipe,
    RecycabilityClassificationPipe,
    IntersectionObserverComponent,
    TranslationsFormComponent,
    PdfButtonComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MultiSelectModule,
    ToastModule,
    AccordionModule,
    AutoCompleteModule,
    InputTextModule,
    KeyFilterModule,
    OverlayPanelModule,
    LightboxModule
  ],
  providers: [
    HttpService,
    AuthService,
    AuthGuard,
    MasterHttpService,
    FileHttpService,
    MasterResolver,
    ProjectHttpService,
    ProjectOptionsResolver,
    UserHttpService,
    UserOptionsResolver,
    CustomerOptionsResolver,
    CustomerHttpService,
    GlobalizationHttpService,
    PrintHttpService
  ],
  exports: [
    EntriesPipe,
    FilterPipe,
    SelectComponent,
    UserSelectComponent,
    MultiselectComponent,
    MultiuserselectComponent,
    PercentInputComponent,
    DecimalInputComponent,
    FlagsSelectComponent,
    ImageInputComponent,
    ImageTaglineInputComponent,
    AttachmentInputComponent,
    CustomerFormComponent,
    MultiSelectModule,
    ToastModule,
    AccordionModule,
    AutoCompleteModule,
    OverlayPanelModule,
    LightboxModule,
    InputTextModule,
    KeyFilterModule,
    SortableTableHeaderComponent,
    LengthPipe,
    FloorPipe,
    ClassificationsInputComponent,
    TooltipComponent,
    TendencyPipe,
    RecycabilityClassificationPipe,
    IntersectionObserverComponent,
    TranslationsFormComponent,
    PdfButtonComponent
  ]
})
export class SharedModule {

  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        HttpService,
        AuthService,
        AuthGuard,
        MasterHttpService,
        MasterService,
        MasterResolver,
        ProjectHttpService,
        ProjectOptionsResolver,
        UserHttpService,
        UserOptionsResolver,
        CustomerOptionsResolver,
        PackagingHttpService,
        CustomerHttpService,
        GlobalizationHttpService
      ]
    };
  }
}
